import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import BottomNav from './components/BottomNav';
import Agenda from './pages/Agenda';
import NovoAgendamento from './pages/NovoAgendamento';
import Disponivel from './pages/Disponivel';
import Configuracoes from './pages/Configuracoes';
import Login from './pages/Login'; // <-- Importação da nossa nova tela de Login

export default function App() {
  // --- INÍCIO DA LÓGICA DE LOGIN ---
  const [autenticado, setAutenticado] = useState(false);

  useEffect(() => {
    // Quando o App carrega, ele checa se já existe a 'chave' guardada no navegador
    const token = localStorage.getItem('mayne_token');
    if (token) {
      setAutenticado(true);
    }
  }, []);

  const handleLogout = () => {
    // Remove a chave e desloga a usuária
    localStorage.removeItem('mayne_token');
    setAutenticado(false);
  };

  // Se não estiver logada, a única coisa que o App renderiza é a tela de Login
  if (!autenticado) {
    return <Login onLoginSuccess={() => setAutenticado(true)} />;
  }
  // --- FIM DA LÓGICA DE LOGIN ---


  // Se passar pela verificação acima (estiver logada), renderiza o sistema normalmente:
  return (
    <BrowserRouter>
      {/* Botão flutuante para deslogar do sistema */}
      <button 
        onClick={handleLogout} 
        style={{
          position: 'fixed', 
          top: '20px', 
          right: '20px', 
          padding: '10px 20px', 
          background: '#FFFFFF', 
          border: '1px solid #EBE6E0', 
          borderRadius: '8px', 
          color: '#A67C7C', 
          cursor: 'pointer',
          fontWeight: '600',
          zIndex: 1000,
          fontSize: '11px',
          fontFamily: '"Montserrat", sans-serif',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.02)'
        }}
        title="Sair do Sistema"
      >
        Sair
      </button>

      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            fontFamily: 'var(--font-body)',
            fontSize: '0.875rem',
            borderRadius: 'var(--radius-md)',
            background: 'var(--charcoal)',
            color: 'var(--white)',
          },
          success: {
            iconTheme: { primary: '#5A7A65', secondary: '#fff' },
          },
          error: {
            iconTheme: { primary: 'var(--rose)', secondary: '#fff' },
          },
        }}
      />
      <Routes>
        <Route path="/"              element={<Agenda />} />
        <Route path="/novo"          element={<NovoAgendamento />} />
        <Route path="/disponivel"    element={<Disponivel />} />
        <Route path="/configuracoes" element={<Configuracoes />} />
      </Routes>
      <BottomNav />
    </BrowserRouter>
  );
}